@keyframes fade-in {
  from {
    background-color: transparent;
  }
}

@keyframes fade-out {
  to {
    background-color: transparent;
  }
}

.drawer {
  --drawer-desktop-padding-horiz: 40px;
  --drawer-mobile-padding-horiz: 24px;
  --drawer-padding-vert: 16px;

  z-index: var(--layers-drawer);
}

.rc-drawer-section {
  width: 100%;
  height: 100%;
  background: var(--colors-grays-white);
  pointer-events: auto;
  overflow: auto;
  display: flex;
  flex-direction: column;
}

.rc-drawer-mask {
  z-index: var(--layers-drawer);
}

.rc-drawer-mask--in {
  animation: fade-in 500ms linear;
}

.rc-drawer-mask--out {
  animation: fade-out 500ms linear;
}
